const ANALYTICS_CATEGORY = 2; // Confirm with Privacy team

// Keep false until Privacy confirms whether implied consent is sufficient.
const ALLOW_IMPLIED_CONSENT = false;

const CONSENT_CHECK_INTERVAL = 250;

const getAnalyticsConsent = () => {
  try {
    if (!window.truste || !window.truste.cma || typeof window.truste.cma.callApi !== 'function') {
      return null;
    }

    const result = window.truste.cma.callApi('getGDPRConsentDecision', window.location.host);

    if (!result || !Array.isArray(result.consentDecision) || result.consentDecision.includes(0)) {
      return false;
    }

    if (result.source === 'implied' && !ALLOW_IMPLIED_CONSENT) {
      return false;
    }

    if (result.source !== 'asserted' && result.source !== 'implied') {
      return false;
    }

    return result.consentDecision.includes(ANALYTICS_CATEGORY);
  } catch (error) {
    // If TrustArc fails, do not enable Analytics.
    return false;
  }
};

export const subscribeToAnalyticsConsent = (callback) => {
  let active = true;
  let intervalId = null;

  const checkConsent = () => {
    if (!active) return false;

    // Wait for TrustArc to initialize.
    if (!window.truste || !window.truste.cma || typeof window.truste.cma.callApi !== 'function') {
      return false;
    }

    callback(getAnalyticsConsent());
    return true;
  };

  const handleConsentMessage = (event) => {
    if (!event.data) return;

    try {
      const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;

      if (data && data.PrivacyManagerAPI && data.PrivacyManagerAPI.action === 'getConsentDecision') {
        // Re-read the granular decision after a consent change.
        checkConsent();
      }
    } catch (error) {
      // Ignore unrelated or invalid messages.
    }
  };

  window.addEventListener('message', handleConsentMessage);

  // Ask TrustArc to notify the page about consent decisions.
  if (window.top) {
    window.top.postMessage(
      JSON.stringify({
        PrivacyManagerAPI: {
          action: 'getConsentDecision',
          timestamp: new Date().getTime(),
          self: window.location.host,
        },
      }),
      '*'
    );
  }

  // Check immediately, then wait for TrustArc if it is not ready.
  if (!checkConsent()) {
    intervalId = window.setInterval(() => {
      if (checkConsent() && intervalId !== null) {
        window.clearInterval(intervalId);
        intervalId = null;
      }
    }, CONSENT_CHECK_INTERVAL);
  }

  // Return cleanup function for React's useEffect.
  return () => {
    active = false;

    window.removeEventListener('message', handleConsentMessage);

    if (intervalId !== null) {
      window.clearInterval(intervalId);
    }
  };
};
